import React from 'react'
import { get } from 'lodash'
import moment from 'moment'
import { Text } from '../../common'

// Creación OP -> creationDate
// Recibe -> firstName + lastName
// RUT -> document
// Entrega ->shippingEstimateDate (solo la fecha, no horario)
// Promesa entrega -> startDateUtc + endDateUtc (solo horario, no fecha)
// Despacho ->price

const OrderCardShipping = (data) => {
  const { salesChannel, logisticsInfo, selectedAddress } = data
  return {
    title: <Text strong text={get(salesChannel, 'name')} />,
    subtitle: (subtitle = 'Jumbo Los Domínicos') =>
      <div className=''>
        <Text subtitle tiny text='order_detail.delivery_mode' />
        <span className='separator tiny'>|</span>
        <Text subtitle tiny text={get(logisticsInfo, 'selectedSla')} />
      </div>,
    info: [
      { title: <Text tiny text='order_detail.created_at' />, value: <Text tiny text={moment(get(data, 'createdAt')).format('DD/MM/YYYY HH:mm a')} /> },
      { title: <Text tiny text='order_detail.receiver_name' />, value: <Text tiny text={get(selectedAddress, 'receiverName')} /> },
      { title: <Text tiny text='order_detail.receiver_document' />, value: <Text tiny text={get(selectedAddress, 'receiverDocument', 'XX.XXX.XXX-X')} /> },
      { title: <Text tiny text='order_detail.shipping_estimate_date' />, value: <Text tiny text={moment(get(logisticsInfo, 'shippingEstimateDate')).format('LL')} /> },
      { title: <Text tiny text='order_detail.shipping_promised_date' />, value: <Text tiny text={moment(get(logisticsInfo, 'shippingEstimateDate')).format('HH:mm a')} /> },
      { title: <Text tiny text='order_detail.delivery_price' />, value: <Text tiny text={`$ ${get(logisticsInfo, 'deliveryWindow.price')}`} /> }
    ]
  }
}

export default OrderCardShipping
